import React, { Component } from 'react'
import { connect } from 'react-redux'
import { dataType } from '@/constants/data-type'

import '@/companys/ttl/assets/styles/components/market/market-hk.scss'
import '@/assets/styles/commons/_styles.scss'

import DataTable from '@/components/DataTable/DataTable'
import MarketIndex from '@/components/MarketIndex/MarketIndex'
import { Comparator, utilsFunction } from '@/helpers/functions'

import { stockActions } from '@/actions/trading/stock.action'

class Market_HK extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeData: [],
      gainersData: [],
      losersData: [],
      ColumnDefs: [
        {
          headerName: props.language.common_symbol,
          colId: 'common_symbol',
          field: 'symbol',
          tooltipField:"symbol",
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SYMBOL,
          minWidth: 80
        },
        {
          headerName: props.language.common_name,
          colId: 'common_name',
          field: 'stockName',
          tooltipField:'stockName',
          headerClass: 'table-header',
          cellClass: 'table-cell table-ellipsis',
          dataType: dataType.TEXT
        },
        {
          headerName: props.language.common_price,
          colId: 'common_price',
          field: 'price',
          tooltipField: 'price',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 60
        },
        {
          headerName: props.language.common_change,
          colId: 'common_change',
          field: 'change',
          tooltipField: 'change',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          bindingColor: true,
          dataType: dataType.PERCENT_BASED,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.common_turnover_rate,
          colId: 'common_turnover_rate',
          field: 'rate',
          tooltipField: 'rate',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.PERCENT_BASED,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.common_turnover,
          colId: 'common_turnover',
          field: 'turnover',
          tooltipField: 'turnover',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.common_bid,
          colId: 'common_bid',
          field: 'bid',
          tooltipField: 'bid',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.common_ask,
          colId: 'common_ask',
          field: 'ask',
          tooltipField: 'ask',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.common_volume,
          colId: 'common_volume',
          field: 'volume',
          tooltipField: 'volume',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          minWidth: 70
        },
        {
          headerName: props.language.common_open,
          colId: 'common_open',
          field: 'open',
          tooltipField: 'open',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.market_quote_prev_close,
          colId: 'market_quote_prev_close',
          field: 'close',
          tooltipField: 'close',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.common_high,
          colId: 'common_high',
          field: 'high',
          tooltipField: 'high',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.common_low,
          colId: 'common_low',
          field: 'low',
          tooltipField: 'low',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator
        }
      ].filter(Boolean),
      isWatchList: false,
      reSendActiveStock: false,
      charts: [
        { exchangeID: "HK", key: "HSI" },
        { exchangeID: "HK", key: "HSCEI" },
        { exchangeID: "HK", key: "HSTECH" },
        { exchangeID: "HK", key: "HSCCI" },
      ]
    }
    if (props.innerRef) {
      props.innerRef(this)
    }
  }
  render() {
    const { language } = this.props
    const { ColumnDefs, activeData, gainersData, losersData, charts } = this.state
    return (
      <div className='market_hk'>
        <div className='hk_left'>
          <div className='left_top'>
            <div className='title'>{language.market_index_chart}</div>
            <MarketIndex data={charts} innerRef={e => (this.chartsRef = e)} />
          </div>
          <div className='Most'>
            <div className='title'>{language.market_turnover_ranking}</div>
            <DataTable showPagination={false} columnDefs={ColumnDefs} data={activeData} innerRef={e => (this.activeRef = e)}></DataTable>
          </div>
        </div>
        <div className='hk_right'>
          <div className='right_top'>
            <div className='title'>{language.market_gainers}</div>
            <DataTable showPagination={false} columnDefs={ColumnDefs} data={gainersData} innerRef={e => (this.GainersRef = e)}></DataTable>
          </div>
          <div className='right_bottom'>
            <div className='title'>{language.market_losers}</div>
            <DataTable showPagination={false} columnDefs={ColumnDefs} data={losersData} innerRef={e => (this.LoserRef = e)}></DataTable>
          </div>
        </div>
      </div>
    )
  }
  componentDidMount() {
    const { currentTradingAccount, token, mdsToken } = this.props
    if (currentTradingAccount && token && mdsToken) {
      this.getMostActiveStocks()
      this.getGainers()
      this.getLosers()
    }
  }

  componentDidUpdate(preProps) {
    const { currentTradingAccount, isNeedRefresh, language, mdsToken } = this.props
    if (JSON.stringify(currentTradingAccount) == '{}' && preProps.currentTradingAccount !== currentTradingAccount) {
      this.getMostActiveStocks()
      this.getGainers()
      this.getLosers()
    }
    if (isNeedRefresh && preProps.isNeedRefresh !== isNeedRefresh) {
      this.getMostActiveStocks()
      this.getGainers()
      this.getLosers()
    }
    if (language && preProps.language !== language) {
      this.getMostActiveStocks()
      this.getGainers()
      this.getLosers()
    }
    if (preProps.mdsToken != mdsToken && mdsToken) {
      this.getMostActiveStocks()
      this.getGainers()
      this.getLosers()
    }
  }

  updateCharts() {
    this.chartsRef.updateCharts()
  }

  InterfaceRequest(params, savedata, callback) {
    const { language, mdsToken } = this.props
    const data = []
    this.props.getTopRank(params, quest => {
      if (quest.rtnCode) {
        this.setState({ [savedata]: [] })
        callback()
        return
      }
      for (let i = 0; i < 20; i++) {
        const sample = ['symbol', 'stockName', 'price', 'change', 'bid', 'ask', 'volume', 'rate', 'open', 'close', 'high', 'low', 'turnover'].reduce(
          (prev, next) => ((prev[next] = '-'), prev),
          {}
        )
        const deepSample = JSON.parse(JSON.stringify(sample))
        const dparams = { symbols: [{ exchangeID: quest.elements[i]?.exchangeID, key: quest.elements[i]?.code }], sessID: mdsToken }
        this.props.getDetailPriceInfo(dparams, quetores => {
          let rq = quest.elements[i]
          if (quetores) {
            const twoNewRowData = JSON.parse(JSON.stringify(this.state[savedata]))
            if (twoNewRowData) {
              const deepSample = twoNewRowData[i]
              for (let i = 0; i < 4; i++) {
                if (rq.code.length < 5) {
                  rq.code = '0' + rq.code
                }
              }
              rq.exchangeID = rq.exchangeID + '.'
              deepSample.symbol = rq.exchangeID + rq.code
              const lang = language.lang
              if (lang === 'zh_TW') {
                deepSample.stockName = rq.tcName
              } else if (lang === 'zh_CN') {
                deepSample.stockName = rq.scName
              } else {
                deepSample.stockName = rq.name
              }
              deepSample.price = quetores.last
              deepSample.change = `${utilsFunction.datatableCurrencyFormatter(quetores.last - quetores.prev)} (${utilsFunction.datatableFormatPercent(
                ((quetores.last - quetores.prev) / quetores.prev) * 100
              )})`
              deepSample.bid = quetores.bids?.[0]?.price
              deepSample.ask = quetores.asks?.[0]?.price
              deepSample.vol = quetores.vol
              deepSample.rate = quetores.turnoverRate ? utilsFunction.formatPercent(quetores.turnoverRate) : '-'
              deepSample.open = quetores.turnoverRateopen
              deepSample.close = quetores.prev
              deepSample.high = quetores.high
              deepSample.low = quetores.low
              deepSample.turnover = quetores.turnover
              this.setState({ [savedata]: twoNewRowData })
            }
          }
        },(res)=>{
          const twoNewRowData = JSON.parse(JSON.stringify(this.state[savedata]))
          if(twoNewRowData){
            const deepSample = twoNewRowData[i]
            let rq = quest.elements[i]
            for (let i = 0; i < 4; i++) {
              if (rq.code.length < 5) {
                rq.code = '0' + rq.code
              }
            }
            rq.exchangeID = rq.exchangeID + '.'
            deepSample.symbol = rq.exchangeID + rq.code
            const lang = language.lang
            if (lang === 'zh_TW') {
              deepSample.stockName = rq.tcName
            } else if (lang === 'zh_CN') {
              deepSample.stockName = rq.scName
            } else {
              deepSample.stockName = rq.name
            }
            this.setState({ [savedata]: twoNewRowData })
          }
        })
        data.push(deepSample)
      }
      this.setState({ [savedata]: data })
      typeof callback === 'function' && callback()
    })
  }
  getMostActiveStocks = () => {
    this.activeRef.toggleLoadingOverlay(true)
    this.setState({ activeData: null })
    const { mdsToken } = this.props
    const params = {
      symbols: [{ exchangeID: 'HK', key: 'OrinaryShare-Turnover' }],
      sessID: mdsToken
    }
    this.InterfaceRequest(params, 'activeData', () => {
      this.activeRef.toggleLoadingOverlay(false)
    })
  }
  getGainers = () => {
    this.GainersRef.toggleLoadingOverlay(true)
    this.setState({ gainersData: null })
    const { mdsToken } = this.props
    const params = {
      symbols: [{ exchangeID: 'HK', key: 'OrinaryShare-NetGainPercent' }],
      sessID: mdsToken
    }
    this.InterfaceRequest(params, 'gainersData', () => {
      this.GainersRef.toggleLoadingOverlay(false)
    })
  }
  getLosers = () => {
    this.LoserRef.toggleLoadingOverlay(true)
    this.setState({ losersData: null })
    const { mdsToken } = this.props
    const params = {
      symbols: [{ exchangeID: 'HK', key: 'OrinaryShare-NetLossPercent' }],
      sessID: mdsToken
    }
    this.InterfaceRequest(params, 'losersData', () => {
      this.LoserRef.toggleLoadingOverlay(false)
    })
  }
}

export default connect(
  state => ({
    language: state.app.language,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount,
    markets: [{ label: state.app.language.market_all, value: '' }, ...state.trade.markets],
    isNeedRefresh: state.refresh.orderTable,
    token: state.auth.token,
    theme: state.app.theme,
    mdsToken: state.trade.mdsToken
  }),
  dispatch => ({
    getTopRank: (p, c) => stockActions.getTopRankAction(p, c),
    getDetailPriceInfo: (p, c, e) => dispatch(stockActions.getDetailPriceInfoAction(p, c, e))
  })
)(Market_HK)
